import React, { useContext, useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Paper, List, ListItem, Button } from '@material-ui/core'
import {
  AccountCircle,
  PersonRounded,
  PeopleRounded,
  ExitToAppRounded,
  LockOpenRounded,
  LockRounded,
  DialpadRounded,
  LocalCarWashRounded
} from '@material-ui/icons'

import { context, useSelectors, userSignOut } from '../../../../store'
import { CustomRouterLink } from '../../../../components/custom-router-link'
import { bookingPath } from '../../../../lib/booking-entry'
import { styles } from './styles'

// Once per module: makeStyles called inside a render built a new JSS sheet,
// with new class names, on every render (booking screen, 11 Oct 2026).
const useStyles = makeStyles(styles)

export const UserMenu = React.memo(() => {
  const classes = useStyles()
  const { dispatch } = useContext(context)
  const { isUserSignedIn, userName } = useSelectors()

  const handleSignOut = useCallback(() => dispatch(userSignOut()), [dispatch])

  const renderMenuItem = useCallback(
    (name, icon, href, onClick) => (
      <ListItem className={classes.item} disableGutters>
        <Button className={classes.button} component={CustomRouterLink} to={href} onClick={onClick}>
          <div className={classes.icon}>{icon}</div>
          {name}
        </Button>
      </ListItem>
    ),
    [classes]
  )

  return (
    <Paper className={classes.container}>
      <List className={classes.list}>
        {isUserSignedIn && renderMenuItem(userName, <AccountCircle />, '/user')}
        {isUserSignedIn && renderMenuItem('Book a wash', <LocalCarWashRounded />, bookingPath())}
        {isUserSignedIn && renderMenuItem('Enter promo code', <DialpadRounded />, '/user/promo_code')}
        {isUserSignedIn && renderMenuItem('Change password', <LockRounded />, '/user/reset_password')}
        {isUserSignedIn && renderMenuItem('Sign out', <ExitToAppRounded />, '/', handleSignOut)}
        {!isUserSignedIn && renderMenuItem('Sign in', <PersonRounded />, '/user/sign_in')}
        {!isUserSignedIn && renderMenuItem('Sign up', <PeopleRounded />, '/user/sign_up')}
        {!isUserSignedIn && renderMenuItem('Forgot password', <LockOpenRounded />, '/user/restore_password')}
      </List>
    </Paper>
  )
})
